module.exports = __webpack_public_path__ + "img/bar_01.30c83529.jpg";